import styled from 'styled-components';

import { px } from '../../../../../../contrib/ui';

export const GroupStyled = styled.div`
  padding: ${px(10)} ${px(20)};

  .group-header > div {
    align-items: center;
    color: var(--grey4A);
    font-family: 'DINNextLTPro-Bold';
    font-size: ${px(14)};
  }

  .group-header {
    .autocomplete-wrapper {
      width: ${px(150)};
    }
  }

  .circle-slots {
    margin-left: ${px(20)};
    display: flex;
  }
  .circle-slot {
    height: ${px(24)};
    width: ${px(24)};
    border: 2px solid var(--grey87);
    background-color: white;
    border-radius: 50%;
    margin: 0 ${px(6)};
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px 0 rgba(24, 31, 77, 0.15);

    &:before {
      transition: all 0.5s ease-in-out;
      border-radius: 50%;
      content: '';
      display: block;
      height: ${px(16)};
      width: ${px(16)};
    }

    &.filled {
      &:before {
        background-color: var(--teal);
        box-shadow: 0 2px 4px 0 rgba(24, 31, 77, 0.15);
      }
    }
  }

  .expansion-panel-details {
    &.individual {
      padding: 0;
      padding-left: ${px(15)};
      padding-right: ${px(15)};
      padding-bottom: ${px(15)};
    }
    &.group {
      padding-left: ${px(15)};
      padding-right: ${px(15)};
      padding-bottom: ${px(15)};

      .grid-container {
        .grid-item {
          margin-bottom: 0;

          .team-card {
            margin-top: 0;
          }
        }
      }
    }
  }

  .group-grid {
    display: flex;
    justify-content: space-evenly;
    width: 100%;

    .team-vs,
    .team-header {
      display: none;
    }

    .single-row .single-vs {
      display: none;
    }

    &.team-vs {
      .team-vs {
        visibility: hidden;
        opacity: 0;
        transition: opacity 0.5s ease-in-out;
        align-items: center;
        background-color: var(--dark);
        border: 1px solid #ffffff;
        display: flex;
        height: ${px(40)};
        justify-content: center;
        position: absolute;
        top: ${px(92)};
        transform: rotate(-45deg);
        width: ${px(40)};
        span {
          display: block;
          transform: rotate(45deg) translateY(2px);
          color: white;
          font-family: 'DINNextLTPro-Bold';
        }
      }
    }

    &.single-vs {
      .single-row {
        position: relative;

        .single-vs {
          display: none;
          align-items: center;
          background-color: var(--dark);
          border: 1px solid #ffffff;
          display: flex;
          height: ${px(28)};
          justify-content: center;
          opacity: 0;
          position: absolute;
          right: ${px(-32)};
          top: ${px(12)};
          transform: rotate(45deg);
          transition: opacity 0.5s ease-in-out;
          transform-origin: top left;
          visibility: hidden;
          width: ${px(28)};
          z-index: 99;
          span {
            color: white;
            display: block;
            font-family: 'DINNextLTPro-Bold';
            font-size: ${px(14)};
            transform: rotate(-45deg) translateY(2px);
          }
        }
      }
    }

    &.teams {
      .team-header {
        display: block;
      }
      .team-side {
        border: 1px solid #e7e7e7;
        border-radius: 5px;
        background-color: var(--greyf9);
        box-shadow: 0 0 15px 0 rgba(24, 31, 77, 0.15);
        padding: 10px 6px 0;
        margin-bottom: ${px(10)};

        .team-header {
          margin-bottom: ${px(10)};
          .team-name {
            color: var(--grey4a);
            font-family: 'DINNextLTPro-Heavy';
            font-size: ${px(18)};
            line-height: ${px(26)};
            text-align: center;
            margin: 0;
            padding: 0;
          }
          .team-stat {
            display: flex;
            color: var(--grey87);
            font-family: 'DINNextLTPro-Medium';
            font-size: ${px(14)};
            line-height: ${px(18)};

            .stat-title {
              width: 95px;
              margin-left: calc(60% - ${px(95)});
            }
            .stat-value {
              color: var(--grey4a);
            }
          }
        }
      }
    }

    .player-card .player-card-info .values {
      width: 100%;
    }

    .left-players,
    .right-players {
      width: 48%;

      .single-row {
        margin-bottom: ${px(20)};
      }
    }

    @media (min-width: 300px) and (max-width: 767px) {
      display: block;

      .left-players,
      .right-players {
        padding: 0 2vh;
        width: 100%;
      }
    }
  }

  .action-button {
    height: ${px(31)};
    width: calc(50% - ${px(5)});
    color: white;
    font-family: 'DINNextLTPro-Bold';
    font-size: ${px(14)};
    line-height: ${px(17)};
    text-align: center;
    padding: 0;
  }

  .empty-slot {
    padding: ${px(10)};
    height: ${px(100)};
    border-radius: 5px;
    background-color: rgba(55, 55, 55, 0.9);
    box-shadow: 0 0 15px 0 rgba(24, 31, 77, 0.15);
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  @media (--m-d-viewport) {
    padding: ${px(10)} 0;

    .group-panel {
      .group-header {
      }
    }
    .team-side {
      padding: 0 ${px(5)};
    }
  }
`;
